import { CmsVendor } from "@gatsbyjs/graphql/types"
import {
  AgilityLogo,
  ButtercmsLogo,
  ContentstackLogo,
  ContentfulLogo,
  CosmicLogo,
  DatocmsLogo,
  DrupalLogo,
  FlotiqLogo,
  PrismicLogo,
  SanityLogo,
  ShopifyLogo,
  StoryblokLogo,
  StrapiLogo,
  WordpressLogo,
  GraphcmsLogo,
  LogoProps,
} from "gatsby-ui/src/components/icons/logos"

import { FiLayers } from "react-icons/fi"

export type SupportedCmsVendor =
  | CmsVendor.Contentful
  | CmsVendor.Cosmicjs
  | CmsVendor.Datocms
  | CmsVendor.Drupal
  | CmsVendor.Sanity
  | CmsVendor.Shopify
  | CmsVendor.Wordpress
  | CmsVendor.None
  | CmsVendor.Custom
  | CmsVendor.DataSync

export const dataSourceNames: {
  [key: string]: string
} = {
  [CmsVendor.Agility]: `Agility`,
  [CmsVendor.Butter]: `ButterCMS`,
  [CmsVendor.Contentstack]: `Contentstack`,
  [CmsVendor.Contentful]: `Contentful`,
  [CmsVendor.Cosmicjs]: `Cosmic`,
  [CmsVendor.Datocms]: `DatoCMS`,
  [CmsVendor.Drupal]: `Drupal`,
  [CmsVendor.Flotiq]: `Flotiq`,
  GRAPHCMS: `GraphCMS`,
  [CmsVendor.Sanity]: `Sanity`,
  [CmsVendor.Shopify]: `Shopify`,
  [CmsVendor.Storyblok]: `Storyblok`,
  [CmsVendor.Strapi]: `Strapi`,
  [CmsVendor.Storyblok]: `Storyblok`,
  [CmsVendor.Prismic]: `Prismic`,
  [CmsVendor.Wordpress]: `WordPress`,
  [CmsVendor.None]: `Sourcing all data`,
  [CmsVendor.Custom]: `Building Valhalla Schema`,
  [CmsVendor.DataSync]: `Syncing Data to Valhalla API`,
}

export const systemEvents = [
  CmsVendor.None,
  CmsVendor.Custom,
  CmsVendor.DataSync,
]
export const systemEventNames = systemEvents.map(e => dataSourceNames[e])
export const dataSourceLogos: {
  [key: string]: (props: LogoProps) => JSX.Element
} = {
  [CmsVendor.Agility]: AgilityLogo,
  [CmsVendor.Butter]: ButtercmsLogo,
  [CmsVendor.Contentstack]: ContentstackLogo,
  [CmsVendor.Contentful]: ContentfulLogo,
  [CmsVendor.Cosmicjs]: CosmicLogo,
  [CmsVendor.Datocms]: DatocmsLogo,
  [CmsVendor.Drupal]: DrupalLogo,
  [CmsVendor.Flotiq]: FlotiqLogo,
  GRAPHCMS: GraphcmsLogo,
  [CmsVendor.Prismic]: PrismicLogo,
  [CmsVendor.Sanity]: SanityLogo,
  [CmsVendor.Shopify]: ShopifyLogo,
  [CmsVendor.Storyblok]: StoryblokLogo,
  [CmsVendor.Strapi]: StrapiLogo,
  [CmsVendor.Wordpress]: WordpressLogo,
  [CmsVendor.None]: FiLayers,
  [CmsVendor.Custom]: FiLayers,
  [CmsVendor.DataSync]: FiLayers,
}

export const manualIntegrations = [
  {
    name: dataSourceNames[CmsVendor.Wordpress],
    vendor: CmsVendor.Wordpress,
    logo: dataSourceLogos[CmsVendor.Wordpress],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278133949204-Connecting-to-WordPress`,
  },
  {
    name: dataSourceNames[CmsVendor.Drupal],
    vendor: CmsVendor.Drupal,
    logo: dataSourceLogos[CmsVendor.Drupal],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278079844884-Connecting-to-Drupal`,
  },
  {
    name: dataSourceNames[CmsVendor.Contentstack],
    vendor: CmsVendor.Contentstack,
    logo: dataSourceLogos[CmsVendor.Contentstack],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278040351508-Connecting-to-Contentstack`,
  },
  {
    name: dataSourceNames[CmsVendor.Sanity],
    vendor: CmsVendor.Sanity,
    logo: dataSourceLogos[CmsVendor.Sanity],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278099689236-Connecting-to-Sanity-via-Quick-Connect`,
  },
  {
    name: dataSourceNames[CmsVendor.Prismic],
    vendor: CmsVendor.Prismic,
    logo: dataSourceLogos[CmsVendor.Prismic],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278009387028-Connecting-to-Prismic`,
  },
  {
    name: dataSourceNames[CmsVendor.Strapi],
    vendor: CmsVendor.Strapi,
    logo: dataSourceLogos[CmsVendor.Strapi],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278146885012-Connecting-to-Strapi`,
  },
  {
    name: dataSourceNames[CmsVendor.Butter],
    vendor: CmsVendor.Butter,
    logo: dataSourceLogos[CmsVendor.Butter],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17277989831060-Connecting-to-ButterCMS`,
  },
  {
    name: dataSourceNames[CmsVendor.Agility],
    vendor: CmsVendor.Agility,
    logo: dataSourceLogos[CmsVendor.Agility],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278044291476-Connecting-to-Agility`,
  },
  {
    name: dataSourceNames[CmsVendor.Flotiq],
    vendor: CmsVendor.Flotiq,
    logo: dataSourceLogos[CmsVendor.Flotiq],
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278081015700-Connecting-to-Flotiq`,
  },
  {
    name: `Graph CMS`,
    logo: dataSourceLogos.GRAPHCMS,
    docsPath: `https://support.gatsbyjs.com/hc/en-us/articles/17278081789588-Connecting-to-GraphCMS`,
  },
]

export const dataLayerReadyIntegrations = [
  CmsVendor.Wordpress,
  CmsVendor.Drupal,
  CmsVendor.Contentful,
]

export const GATSBY_VERSION_FOR_DATA_LAYER = `>=4.24.6`
